import { BaseSvgIcon } from './BaseSvgIcon'

export const ArrowRightIcon = (props: any) => {
  const { width = 25, height = 25, fill = 'currentColor', ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 1024 1024" fill="none" {...rest}>
      <path d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z" fill={fill} />
    </BaseSvgIcon>
  )
}
